<span class="form-label" translate>Slice settings</span>
<ul class="list-group">
  <!--    FIRST RANGE-->
  <li class="list-group-item">
    <div class="row">
      <div class="col align-items-center d-flex">
        <scitis-color-picker
          (selectedColor)="onSelectSliceColor($event,1)"
          [displayInput]="false"
          [displayLabel]="false"
          [signalColor]="getHexColor(1)"
          class="mr-2">
        </scitis-color-picker>
        <strong translate>Slice One</strong>
      </div>
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>Start</span>
          </div>
          <input (change)="settingValueChange('min')"
            [(ngModel)]="this.signal.boundaries.min"
            class="form-control"
            placeholder="00"
            type="number">
          </div>
        </div>
        <div class="col">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                End
              </span>
            </div>
            <input (change)="settingValueChange('area1End')"
              [(ngModel)]="this.signal.boundaries.area1End"
              class="form-control"
              placeholder="00"
              type="number">
            </div>
          </div>
        </div>
      </li>

      <!--    SECOND RANGE-->
      <li class="list-group-item">
        <div class="row">
          <div class="col align-items-center d-flex">
            <scitis-color-picker
              (selectedColor)="onSelectSliceColor($event,2)"
              [displayInput]="false"
              [displayLabel]="false"
              [signalColor]="getHexColor(2)"
              class="mr-2">
            </scitis-color-picker>
            <strong translate>Slice Two</strong>
          </div>
          <div class="col">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>Start</span>
              </div>
              <input [(ngModel)]="this.signal.boundaries.area1End"
                class="form-control" disabled
                placeholder="00"
                type="number">
              </div>
            </div>
            <div class="col">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">End</span>
                </div>
                <input (change)="settingValueChange('area2End')"
                  [(ngModel)]="this.signal.boundaries.area2End"
                  class="form-control"
                  placeholder="00"
                  type="number">
                </div>
              </div>
            </div>
          </li>

          <!--    THIRD RANGE-->
          <li class="list-group-item">
            <div class="row">
              <div class="col align-items-center d-flex">
                <scitis-color-picker
                  (selectedColor)="onSelectSliceColor($event,3)"
                  [displayInput]="false"
                  [displayLabel]="false"
                  [signalColor]="getHexColor(3)"
                  class="mr-2">
                </scitis-color-picker>
                <strong translate>Slice Three</strong>
              </div>
              <div class="col">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" translate>Start</span>
                  </div>
                  <input [(ngModel)]="this.signal.boundaries.area2End"
                    class="form-control"
                    disabled
                    placeholder="00"
                    type="number">
                  </div>
                </div>
                <div class="col">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">End</span>
                    </div>
                    <input (change)="settingValueChange('max')"
                      [(ngModel)]="this.signal.boundaries.max"
                      class="form-control"
                      placeholder="00"
                      type="number">
                    </div>
                  </div>
                </div>
              </li>

              <!--    TRANSITION CHECKBOX-->
              @if (isGaugeWidget && isModernGauge) {
                <li class="list-group-item">
                  <div class="custom-control custom-switch d-inline-flex">
                    <input
                      (change)="onColorTransitionChange($event)"
                      [checked]="this.signal.transition"
                      class="custom-control-input" id="isColorTransition"
                      type="checkbox">
                      <label class="custom-control-label" for="isColorTransition" translate>Transition between colors</label>
                    </div>
                  </li>
                }
              </ul>